import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { AdVideoPrerollComponent } from './ad-video-preroll/ad-video-preroll.component'
import { VideoAdsService } from './services/video-ads.service'
import { OldSvgModule } from 'src/app/libs/_deprecated/svg/old-svg.module'
import { FloPipeModule } from '../pipes/flo-pipe.module'
import { VideoErrorModule } from '../video-player/components/video-error/video-error.module'

@NgModule({
  imports: [CommonModule, OldSvgModule, FloPipeModule, VideoErrorModule],
  declarations: [AdVideoPrerollComponent],
  providers: [VideoAdsService],
  exports: [AdVideoPrerollComponent]
})
export class AdsModule {}
